// export const BASE_URL = 'http://localhost:3004';
export const BASE_URL = 'https://routemap.inmapz.com';
export const API_PATH = '/api';

//Google Geocoding
export const GEOCODING_URL = 'https://maps.googleapis.com/maps/api/geocode/json';
export const GOOGLE_API_KEY = 'AIzaSyDL41qTlES_0RQUqItpAXD1ufP53hqT1sk';

//Google map token
export const GOOGLE_MAP_TOKEN = 'AIzaSyCa6UQy0Je3R9peVAG2PjuALXiaz6Tiqxw';

//API
export const GET_AIPORT_ITEMS = API_PATH + '/airports';
export const GET_REGIONS = API_PATH + '/regions';
export const GET_All_ROUTES = API_PATH + '/itineraries';
export const GET_ITINERARIES = API_PATH + '/multi-itineraries';
export const GET_ITINERARIES_NETWORK = API_PATH + '/itineraries-network';
export const GET_FLIGHT_NETWORK = API_PATH + '/flight-network';
export const GET_ROUTE_PRICE = API_PATH + '/route-price';


export const BOOKING = `https://www.vietnamairlines.com/{locale}/{lang}/buy-tickets-other-products/booking-and-manage-bookings/book-tickets?from={origin}&to={destination}&utm_source=routemap`;

// export const SCHEDULE = `https://fly.vietnamairlines.com/dx/VNDX/#/flight-schedule?locale={locale}&origin={origin}&destination={destination}&date={date}&journeyType=one-way&utm_source=routemap`;

export const SCHEDULE = `https://www.vietnamairlines.com/{locale}/{lang}/flightschedule?originLocationCode={origin}&destinationLocationCode={destination}&departureDate={date}&utm_source=routemap`;

export const BRANCHES = `https://www.vietnamairlines.com/vn/{lang}/support/vietnam-branches`;
// export const MULTI_DES_BOOKING = `https://www.vietnamairlines.com/{lang}/home?type=multipledestination&utm_source=routemap`;
export const AIRPORT_MAP_URL = `https://www.vietnamairlines.com/{region}/{lang}/home/travel-information/airports-transit/airport-navigation?airport={slug}`;
